import { MutationTree } from "vuex";
import {
  IPromoCodesState,
  PromoCodePaymentMethod,
  IPromoCodeDto
} from "./types";
import { DeliveryMethod } from "../standardOffer/types";

export namespace PROMO_CODES_MUTATIONS {
  export const TOGGLE_IS_LOADING = "toggleIsLoading";

  export const SET_CODE = "setCode";
  export const SET_SINGLE_USE = "setSingleUse";
  export const SET_MEMBERSHIP_NO_REQUIRED = "setMembershipNoRequired";
  export const SET_VALID_FROM_DATE = "setValidFromDate";
  export const SET_VALID_TO_DATE = "setValidToDate";
  export const SET_BENEFITS = "setBenefits";
  export const SET_BENEFITS_HTML = "setBenefitsHTML";
  export const SET_LEGAL = "setLegal";
  export const SET_LEGAL_HTML = "setLegalHTML";
  export const SET_EARNS_LOYALTY_POINTS = "setEarnsLoyaltyPoints";
  export const SET_SKIP_CREDIT_CHECK = "setSkipCreditCheck";
  export const SET_DISCOUNTS_OFF_PUMP = "setIsDiscountOffPump";
  export const SET_PAYMENT_METHOD = "setPaymentMethod";
  export const SET_DELIVERY_METHOD = "setDeliveryMethod";
  export const SET_DISCOUNTS = "setDiscounts";
  export const SET_ACCOUNT_FEE_PROFILE = "setAccountFeeProfile";
  export const SET_CARD_FEE_PROFILE = "setCardFeeProfile";
  export const SET_APPLICATION_TYPE = "setApplicationType";
  export const SET_CUSTOMER_TYPE = "setCustomerType";
  export const SET_CLASS_OF_BUYER = "setClassOfBuyer";
  export const SET_PRICING_PROFILE = "setPricingProfile";
  export const SET_REBATE_PROFILE = "setRebateProfile";
  export const SET_COLLECTION_MANAGER = "setCollectionManager";
  export const SET_SALES_REPRESENTATIVE = "setSalesRepresentative";
  export const SET_PAYMENT_TERM = "setPaymentTerm";

  export const SET_PROMO_CODES_LIST = "setPromoCodesList";
  export const SET_PROMO_CODE = "setPromoCode";
  export const SET_DATA_TABLE_PAGINATION = "setDataTablePagination";
}

export const mutations: MutationTree<IPromoCodesState> = {
  [PROMO_CODES_MUTATIONS.TOGGLE_IS_LOADING](
    state: IPromoCodesState,
    isLoading: boolean
  ): void {
    state.isLoading = isLoading;
  },
  [PROMO_CODES_MUTATIONS.SET_CODE](
    state: IPromoCodesState,
    offerCode: string
  ): void {
    if (state.promoCode) {
      state.promoCode.promoCode = offerCode;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_SINGLE_USE](
    state: IPromoCodesState,
    singleUse: boolean
  ): void {
    if (state.promoCode) {
      state.promoCode.singleUse = singleUse;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_MEMBERSHIP_NO_REQUIRED](
    state: IPromoCodesState,
    value: boolean
  ): void {
    if (state.promoCode) {
      state.promoCode.membershipNoRequired = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_VALID_FROM_DATE](
    state: IPromoCodesState,
    value: Date
  ): void {
    if (state.promoCode) {
      state.promoCode.validFromDate = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_VALID_TO_DATE](
    state: IPromoCodesState,
    value: Date
  ): void {
    if (state.promoCode) {
      state.promoCode.validToDate = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_BENEFITS](
    state: IPromoCodesState,
    benefits: string
  ): void {
    if (state.promoCode) {
      state.promoCode.benefits = benefits;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_BENEFITS_HTML](
    state: IPromoCodesState,
    benefitsHtml: string
  ): void {
    if (state.promoCode) {
      state.promoCode.benefitsHtml = benefitsHtml;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_LEGAL](
    state: IPromoCodesState,
    legal: string
  ): void {
    if (state.promoCode) {
      state.promoCode.legal = legal;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_LEGAL_HTML](
    state: IPromoCodesState,
    legalHtml: string
  ): void {
    if (state.promoCode) {
      state.promoCode.legalHtml = legalHtml;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_EARNS_LOYALTY_POINTS](
    state: IPromoCodesState,
    value: boolean
  ): void {
    if (state.promoCode) {
      state.promoCode.earnsLoyaltyPoints = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_SKIP_CREDIT_CHECK](
    state: IPromoCodesState,
    value: boolean
  ): void {
    if (state.promoCode) {
      state.promoCode.skipCreditCheck = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_DISCOUNTS_OFF_PUMP](
    state: IPromoCodesState,
    value: boolean
  ): void {
    if (state.promoCode) {
      state.promoCode.isDiscountOffPump = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_PAYMENT_METHOD](
    state: IPromoCodesState,
    value: PromoCodePaymentMethod
  ): void {
    if (state.promoCode) {
      state.promoCode.paymentMethod = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_ACCOUNT_FEE_PROFILE](
    state: IPromoCodesState,
    value: string
  ): void {
    if (state.promoCode) {
      state.promoCode.accountFeeProfile = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_CARD_FEE_PROFILE](
    state: IPromoCodesState,
    value: string
  ): void {
    if (state.promoCode) {
      state.promoCode.cardFeeProfile = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_APPLICATION_TYPE](
    state: IPromoCodesState,
    value: string
  ): void {
    if (state.promoCode) {
      state.promoCode.applicationType = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_CUSTOMER_TYPE](
    state: IPromoCodesState,
    value: string
  ): void {
    if (state.promoCode) {
      state.promoCode.customerType = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_CLASS_OF_BUYER](
    state: IPromoCodesState,
    value: string
  ): void {
    if (state.promoCode) {
      state.promoCode.classOfBuyer = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_PRICING_PROFILE](
    state: IPromoCodesState,
    value: string
  ): void {
    if (state.promoCode) {
      state.promoCode.pricingProfile = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_REBATE_PROFILE](
    state: IPromoCodesState,
    value: string[]
  ): void {
    if (state.promoCode) {
      state.promoCode.rebateProfile = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_COLLECTION_MANAGER](
    state: IPromoCodesState,
    value: string
  ): void {
    if (state.promoCode) {
      state.promoCode.collectionManager = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_SALES_REPRESENTATIVE](
    state: IPromoCodesState,
    value: string
  ): void {
    if (state.promoCode) {
      state.promoCode.salesRepresentative = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_PAYMENT_TERM](
    state: IPromoCodesState,
    value: string
  ): void {
    if (state.promoCode) {
      state.promoCode.paymentTerm = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_DISCOUNTS](
    state: IPromoCodesState,
    value: any
  ): void {
    if (state.promoCode) {
      state.promoCode.discounts = value;
    }
  },
  [PROMO_CODES_MUTATIONS.SET_PROMO_CODES_LIST](
    state: IPromoCodesState,
    promoCode
  ): void {
    state.promoCodesList = promoCode;
  },
  [PROMO_CODES_MUTATIONS.SET_PROMO_CODE](
    state: IPromoCodesState,
    promoCode: IPromoCodeDto
  ): void {
    state.promoCode = promoCode;
  },
  [PROMO_CODES_MUTATIONS.SET_DELIVERY_METHOD](
    state: IPromoCodesState,
    deliveryMethod: DeliveryMethod
  ): void {
    state.promoCode.deliveryMethod = deliveryMethod;
  },
  [PROMO_CODES_MUTATIONS.SET_DATA_TABLE_PAGINATION](state, value) {
    state.dataTable.pagination = value;
  }
};
